// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7dbfb42f","453":"3d91d5f6","796":"893c1ad1"}[chunkId] + ".chunk.js";
};